import React from 'react';
import { Modal, Spin, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export const Uploading = () => (
    <Modal
        open
        footer={null}
        closable={false}
        centered
        width={260}
        styles={{ content: { textAlign: 'center', padding: '40px 32px' } }}
        maskStyle={{ backdropFilter: 'blur(4px)' }}
    >
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        <Typography.Text style={{ display: 'block', marginTop: 20, fontSize: 16 }}>
            Saving…
        </Typography.Text>
    </Modal>
);
